// product list
export const PRODUCT_LIST_CONSTANTS = {
    sortOptions: [
        { name: 'قیمت از بیش‌ترین به کم‌ترین', id: 1 },
        { name: 'قیمت از کم‌ترین به بیش‌ترین', id: 2 },
        { name: 'جدیدترین', id: 3 }
    ],
    defaultPageSize: 12,
    defaultSortId: 1,
    defaultContractId: 1,
    countOfFiltersInLessMode: 3,
    maxCountOfComparisonList: 4,
    comparisonCookieExpirsionPeriod: 1 // day
};
